/* Scoped, idempotent and removable: works after Shopify section reloads too. */
(() => {
  if (!window.customElements || customElements.get('ot-water-compare')) return;
  customElements.define('ot-water-compare', class extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected) return;
      this.controller?.abort(); this.controller = new AbortController();
      const stage = this.querySelector('.ot-compare-stage');
      const input = this.querySelector('input[type="range"]');
      if (!stage || !input) return;
      const update = () => {
        const value = Math.min(100, Math.max(0, Number(input.value) || 0));
        stage.style.setProperty('--split', `${value}%`);
        input.setAttribute('aria-valuetext', `${value}% de reflejo en superficie`);
      };
      input.addEventListener('input', update, {signal: this.controller.signal});
      input.addEventListener('change', update, {signal: this.controller.signal});
      update();
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); }
  });
})();
